<template>
  <div class="account-pages my-5 pt-sm-5">
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">Create an Account</h5>
                           <p>Get Started with SpaceMine!</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                    <div class="avatar-md profile-user-wid mb-4">
                      <span class="avatar-title rounded-circle bg-light">
                        <img src="../../assets/images/spacemine-icon.svg" alt="" height="34">
                      </span>
                    </div>
                  </div>
                  <div class="p-2">
                     <form class="form-horizontal" action="index.html">
                        <div class="form-group">
                           <label for="useremail">Email</label>
                           <input v-model="email" type="email" class="form-control" id="useremail" placeholder="Enter email address">
                        </div>
                        <div class="form-group">
                           <label for="userpassword">Password</label>
                           <input v-model="password" type="password" class="form-control" id="userpassword" placeholder="Enter password">
                        </div>
                        <div class="mt-4">
                           <button class="btn btn-primary btn-block waves-effect waves-light" type="submit">Register</button>
                        </div>
                        <div class="mt-4 text-center">
                           <p class="mb-0">By registering you are agreeing to SpaceMine's <a href="#" class="text-primary">Terms of Use</a>, <a href="#" class="text-primary">Acceptable Use Policy</a>, and <a href="#" class="text-primary">Privacy Policy.</a></p>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
            <div class="mt-5 text-center">
               <div>
                  <p>Already have an account? <router-link :to="{ name: 'login' }" class="font-weight-medium text-primary">Login</router-link> </p>
                  <p>
                     Copyright &copy; SpaceMine Ltd. 2017 - {{ year }}.
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
export default
{
  name: 'Register',
  data () {
    return {
      year: (new Date().getFullYear()),
      email: '',
      password: ''
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Register.vue